
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect,useRef,useState } from 'react';
import { _postURL } from "@/api/index";
import Redux, { updatePath } from "@/action";
import _ from 'lodash';
import { HeaderBack } from '@/components/common/header';
import { ViewButton } from '@/components/common/button';
import { _getNextNewsList, _getAllVehicleModelList, _getMinMaxValueArrange, _numToPriceBetween } from '@/libraries/common';
import { pageLimit } from '@/config/site';
import { NewsItem } from '@/components/news';
import Link from 'next/link';
import moment from 'moment';
import { ImageModal } from '@/components/modal';
import { AllMeta } from '@/components/common/meta';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { ProfilePicture } from '../../components/common/image';
import { SkeletonNewsItem } from '../../components/common/skeleton';
import { TagButton } from '../../components/common/button';
import { mobileViewWidth, pageLink, placementArea, videoEmbed } from '../../config/site';
import { Footer } from '../../components/common/footer';
import { _getPlacement, _getS3ListFileImage, _getSFTPListFileImage, _getTransmissionArray, removeIsWebviewPath } from '../../libraries/common';
import { PlacementBanner } from '../../components/placement';
import { RelatedModel } from '../../components/vehicle';
import { Comment, CommentSection } from '../../components/comment';
import { MyBody } from '../../components/body/body';
import { CustomLink } from '../../components/app/customLink';
import { customRouterLink } from '../../libraries/appCommon';

const RelatedNews = (props) => {
    const { t, loading = false, newsList = [] } = props
    if(loading == true){
        return (
            <>
                <div className='newsDetail_related containerPadding'>
                    <p className='fontSize_16 fontWeight_semiBold'>
                        {t('related_news')}
                    </p>
                </div>
                {
                    _.times(3, (key)=>(
                        <SkeletonNewsItem key={key} lineVisible={key == 0 ? false : true} />
                    ))
                }
            </>
        )
    }
    return (
        <>
            {
                !_.isEmpty(newsList) &&
                <>
                    <div className='newsDetail_related containerPadding'>
                        <p className='fontSize_16 fontWeight_semiBold'>
                            {t('related_news')}
                        </p>
                    </div>
                    {
                        _.reduce(newsList, (result, value, key) => {
                            key < 6 ? 
                            result.push(
                                <NewsItem key={key} data={value} lineVisible={key == 0 ? false : true} type={value.type} />
                            )
                            :
                            null
                            return result
                        },[])
                    }
                </>
            }
        </>
    )
}

const ImageList = (props) =>{
    const { data, t } = props
    const [opened, setOpened] = useState(false)
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    return (
        <>
            <div className='imageList containerPadding'>
                <p className='fontSize_16 fontWeight_semiBold'>
                    {t('gallery')}
                </p>
                <div onClick={()=>{setOpened(true); setCurrentIndex(0)}} className='imageList_mainImage cursorPointer'>
                    <div className='imageList_mainImageBackground' style={{backgroundImage: `url(${data[0]})` }} />
                </div>
                <div className='imageList_subImageRow'>
                    {
                        data.length >= 1 &&
                        _.reduce(data, (result, value, key)=>{
                            if(key >= 1 && key <= 3){
                                result.push(
                                    <div onClick={()=>{setOpened(true);setCurrentIndex(key)}} key={key} className='imageList_subImageColumn cursorPointer'>
                                        <div className='imageList_mainImage'>
                                            <div className='imageList_mainImageBackground' style={{backgroundImage: `url(${value})` }}  />
                                            {
                                                (key == 3 && data.length >= 5) &&
                                                <div className='imageList_mainImageBackgroundLast'>
                                                    <p className='fontSize_20 fontWeight_semiBold fontColor_white'>
                                                        + {data.length - 3}
                                                    </p>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                )
                            }
                            return result
                        },[])
                    }
                </div>
            </div>
            <ImageModal
                setOpened={setOpened}
                opened={opened}
                data={data}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
                thumbsSwiper={thumbsSwiper}
                setThumbsSwiper={setThumbsSwiper}
                t={t}
            />
        </>
    )
}

export default function Index(props) {
    const { store, dispatch } = Redux();
    const { t, device, session, newsData } = props;
    const [loading, setLoading] = useState(true);

    // news list
    const [newsList, setNewsList] = useState([]);
    const [offset, setOffset] = useState(0);

    // image Modal
    const [imageList, setImageList] = useState([]);

    // article
    const [articleParagraph, setArticleParagraph] = useState([])

    // Vehicle model List
    const [vehicleModelList, setVehicleModelList] = useState([])
    const containerRef = useRef(null)
    const router = useRouter();

    // Similar Vehicle model List
    const [similarVehicleModelList, setSimilarVehicleModelList] = useState([])

    // Comment
    const [commentList, setCommentList] = useState(undefined);
    const [commentTotalCount, setTotalCommentCount] = useState(0);

    // Drawer Open or not
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        setLoading(true)
        // Find the container element and all img elements with the img-fluid class
        // const container = document.querySelector('.newsDetail_content');
        // const imgElements = container.querySelectorAll('.img-fluid');
    
        // Extract src attributes and store them in an array
        // const srcArray = Array.from(imgElements).map(img => img.getAttribute('src'));
    
        // Use the srcArray as needed (e.g., store it in state, send it to an API, etc.)
        // setImageList(srcArray);

        // this will set placement go inside article
        // const pluginPlacement = container.querySelectorAll('p');
        // setArticleParagraph(pluginPlacement)

        const fetchData = async() => {
            setNewsList([])
            setVehicleModelList([])
            setSimilarVehicleModelList([])
            setImageList([])
            
            if(!_.isEmpty(JSON.parse(newsData?.vehicle_model_id))){
                await _getAllVehicleModelList(setVehicleModelList, {vehicle_model_id_list: _.join(JSON.parse(newsData?.vehicle_model_id), ',')});
            }
            if(!_.isEmpty(JSON.parse(newsData?.similar_vehicle_model_id))){
                await _getAllVehicleModelList(setSimilarVehicleModelList, {vehicle_model_id_list: _.join(JSON.parse(newsData?.similar_vehicle_model_id), ',')});
            }
            if(!_.isEmpty(newsData?.s3key)){
                await _getSFTPListFileImage(setImageList, {pathName: newsData?.s3key})
            }
            if(store?.path?.dataPlacement == undefined){
                await _getPlacement(dispatch)
            }
            if(!_.isEmpty(newsData?.vehicle_brand_id)){
                await _getNextNewsList({offset, limit: pageLimit, vehicleBrand_id: JSON.stringify(JSON.parse(newsData?.vehicle_brand_id)), notinID: newsData?.news_id, noMergeData: true}, setNewsList);
            }
            setLoading(false);
        }
        fetchData();

        if(window.innerWidth <= mobileViewWidth){
            window.scrollTo({
                top: 1,
                behavior: 'instant'
            });
        } else {
            if (containerRef.current) {
                containerRef.current.scrollTo({
                  top: 0,
                  behavior: 'instant'
                });
            }
        }

    }, [newsData]);

    // Reset news detail page comment, not drawer comment
    useEffect(() => {
        setCommentList(undefined);
        setTotalCommentCount(0);
    }, [newsData]);

    return (
        <>
            <AllMeta
                title={newsData?.meta_title}
                description={newsData?.meta_description}
                keyword={newsData?.meta_keyword}
                type="article"
                image={`${process.env.NEXT_PUBLIC_FS_URL}${newsData?.cover_image}`}
                imageWidth={1053}
                imageHeight={552}
            />
            <Head><title>{newsData?.title}</title></Head>
            <MyBody
                t={t}
                headerComponent={
                    <HeaderBack 
                        t={t}
                    />
                }
                showNavigation={true}
                navigationComponent={
                    <div className="vehicleFilter_bottomNavigation containerPadding" style={{ minHeight: '6.5rem', height: 'unset' }}>
                        <Comment 
                            t={t}
                            data={newsData}
                            commentList={commentList}
                            setCommentList={setCommentList}
                            drawerOpen={drawerOpen}
                            setDrawerOpen={setDrawerOpen}
                            loading={false}
                        />
                    </div>
                }
            >
                {(() => {
                    switch(newsData?.type) {
                        case "1":
                            return (
                                <>
                                    <div className='containerPadding newsDetail_title'>
                                        <p className='fontSize_18 fontWeight_bold newsDetail_titleText'>
                                            {newsData?.title}
                                        </p>
                                    </div>
                                    <div className='newsDetail_coverImageOuter'>
                                        <div className='newsDetail_coverImage' style={{backgroundImage: `url(${process.env.NEXT_PUBLIC_FS_URL + newsData?.cover_image})`}} />
                                    </div>
                                </>
                                
                            )
                        case "2":
                            return (
                                <>
                                    <div className='newsDetail_video_youtube'>
                                        <iframe 
                                            className="modal_videoModal_iframe"
                                            width="100%" 
                                            height="100%"
                                            src={`${videoEmbed.youtube}${newsData?.embed_product_id}`}
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen 
                                        />
                                    </div>
                                    <div className='containerPadding newsDetail_title'>
                                        <p className='fontSize_18 fontWeight_bold newsDetail_titleText'>
                                            {newsData?.title}
                                        </p>
                                    </div>
                                </>
                                
                            )
                        case "3":
                            return (
                                <>
                                    <div className='newsDetail_video_tiktok'>
                                        <iframe 
                                            className="modal_videoModal_iframe"
                                            width="100%" 
                                            height="100%"
                                            src={`${videoEmbed.tiktok}${newsData?.embed_product_id}`}
                                            title="Tiktok video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen 
                                            scrolling='no'
                                        />
                                    </div>
                                    <div className='containerPadding newsDetail_title'>
                                        <p className='fontSize_18 fontWeight_bold newsDetail_titleText'>
                                            {newsData?.title}
                                        </p>
                                    </div>
                                </>
                            )
                        default:
                                return (<></>)
                    }
                })()}
                <CustomLink href={`/author/${newsData?.created_by}`}>
                    <div className='newsDetail_author containerPadding cursorPointer'>
                        <ProfilePicture
                            imagePath={!_.isEmpty(newsData?.profile_image) ? process.env.NEXT_PUBLIC_FS_URL + newsData?.profile_image : undefined}
                            size={3.6}
                        />
                        {/* <div className='newsDetail_authorImage' style={{backgroundImage: `url(${process.env.NEXT_PUBLIC_FS_URL + newsData?.profile_image})`}} /> */}
                        <div>
                            <p className='fontSize_12 newsDetail_authorText'>
                                {newsData?.full_name}
                            </p>
                            <p className='fontSize_12 newsDetail_authorDate'>
                                {moment(newsData?.publish_date).format('MMMM DD, YYYY [at] HH:mm')}
                            </p>
                        </div>
                    </div>
                </CustomLink>
                <div className='newsDetail_media containerPadding'>
                    <ViewButton views={newsData?.views} />
                    {
                        _.reduce(JSON.parse(newsData?.vehicle_brand_tag), (result, value, key)=>{
                            if(!_.isEmpty(value)){
                                result.push(
                                    <TagButton key={key} label={value.name} linkUrl={pageLink.vehicle.vehicleMidUrl + value.custom_url} />
                                )
                            }
                            return result
                        },[])
                    }
                </div>
                <div className='mt_25'>
                    <PlacementBanner
                        // can't pass object because inside using memo
                        loading={store?.path?.dataPlacement == undefined ? true : false}
                        area={placementArea?.newsDetailPage_beforeArticle} 
                        placement_id={store?.path?.dataPlacement?.[placementArea?.newsDetailPage_beforeArticle]?.placement_id}
                        type={store?.path?.dataPlacement?.[placementArea?.newsDetailPage_beforeArticle]?.type}
                        image_path={store?.path?.dataPlacement?.[placementArea?.newsDetailPage_beforeArticle]?.image_path}
                        url={store?.path?.dataPlacement?.[placementArea?.newsDetailPage_beforeArticle]?.url}
                        script={store?.path?.dataPlacement?.[placementArea?.newsDetailPage_beforeArticle]?.script}
                    />
                </div>
                {
                    !_.isEmpty(articleParagraph) ?
                    <div className='newsDetail_content'>
                        {
                            _.reduce(articleParagraph, (result, value, key)=>{
                                result.push(<p key={key} dangerouslySetInnerHTML={{ __html: value?.innerHTML }} />)
                                if (value.innerText.trim() !== '') {
                                    result.push(<p key={`placement-${key}`}><PlacementBanner /></p>)
                                }
                                return result
                            },[])
                        }
                    </div>
                    :
                    <div className='newsDetail_content' dangerouslySetInnerHTML={{ __html: newsData.content }} />
                }
                {
                    newsData?.type == 1 && 
                    <div className='mt_25'>
                        <PlacementBanner
                            // can't pass object because inside using memo
                            loading={store?.path?.dataPlacement == undefined ? true : false}
                            area={placementArea?.newsDetailPage_beforeGallery} 
                            placement_id={store?.path?.dataPlacement?.[placementArea?.newsDetailPage_beforeGallery]?.placement_id}
                            type={store?.path?.dataPlacement?.[placementArea?.newsDetailPage_beforeGallery]?.type}
                            image_path={store?.path?.dataPlacement?.[placementArea?.newsDetailPage_beforeGallery]?.image_path}
                            url={store?.path?.dataPlacement?.[placementArea?.newsDetailPage_beforeGallery]?.url}
                            script={store?.path?.dataPlacement?.[placementArea?.newsDetailPage_beforeGallery]?.script}
                        />
                    </div>
                }
                {
                    !_.isEmpty(imageList) &&
                    <ImageList data={imageList} t={t} />
                }
                <div className='newsDetail_shareMedia containerPadding'>
                    <p className='fontSize_14 fontWeight_medium'>
                        {t('share')}
                    </p>
                    <div className="newsDetail_mediaList">
                        <a onClick={()=>{customRouterLink({href: `https://facebook.com/sharer/sharer.php?u=${process.env.NEXT_PUBLIC_FRONTEND_URL + removeIsWebviewPath(router.asPath)}`, action: 'navigationTab', target: '_blank'})}} className="media_icon" rel="noopener noreferrer">
                            <img className='w-100' src="/assets/images/share_icon/facebook_icon.png" />
                        </a>
                        <a onClick={()=>{customRouterLink({href: `https://twitter.com/intent/tweet?url=${process.env.NEXT_PUBLIC_FRONTEND_URL + removeIsWebviewPath(router.asPath)}`, action: 'navigationTab', target: '_blank'})}} className="media_icon" rel="noopener noreferrer">
                            <img className="w-100" src="/assets/images/share_icon/x_icon.png" />
                        </a>
                        <a onClick={()=>{customRouterLink({href: `https://telegram.me/share/url?url=${process.env.NEXT_PUBLIC_FRONTEND_URL + removeIsWebviewPath(router.asPath)}&text=${newsData?.title}`, action: 'navigationTab', target: '_blank'})}} className="media_icon" rel="noopener noreferrer">
                            <img className="w-100" src="/assets/images/share_icon/telegram_icon.png" />
                        </a>
                        <a onClick={()=>{customRouterLink({href: `https://api.whatsapp.com/send?text=${newsData?.title}%20${process.env.NEXT_PUBLIC_FRONTEND_URL + removeIsWebviewPath(router.asPath)}`, action: 'navigationTab', target: '_blank'})}} className="media_icon" rel="noopener noreferrer">
                            <img className='w-100' src="/assets/images/share_icon/whatsapp_icon.png" />
                        </a>
                    </div>
                </div>
                <RelatedModel
                    vehicleModelList={vehicleModelList}
                    t={t}
                    loading={loading}
                />
                <RelatedModel
                    vehicleModelList={similarVehicleModelList}
                    t={t}
                    loading={loading}
                    isSimilar={true}
                />
                <CommentSection 
                    t={t}
                    data={newsData}
                    commentTotalCount={newsData?.total_comment}
                    commentList={commentList}
                    drawerOpen={drawerOpen}
                    setDrawerOpen={setDrawerOpen}
                    loading={false}
                />
                <RelatedNews 
                    t={t}
                    loading={loading}
                    newsList={newsList}
                />
            </MyBody>
        </>
    )
}

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking'
    };
}

export async function getStaticProps({ locale, params: { id } }) {
    try {
        const [
            { value: { data: newsData } },
        ] = await Promise.allSettled([
            _postURL(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/news/getNewsArticle`, { id: id }), // custom url
        ]);
        
        if (_.isEmpty(newsData)) throw new Error();

        return {
            props: {
                newsData,
                ...(await serverSideTranslations(locale, ['common'])),
            },
            revalidate: 5
        };

    } catch (error) {
        return {
            notFound: true,
        }
    }
}